import { render, staticRenderFns } from "./AdmisionRevisarAptitud.vue?vue&type=template&id=334fc3e8"
import script from "./AdmisionRevisarAptitud.vue?vue&type=script&lang=js"
export * from "./AdmisionRevisarAptitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports